import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faEye } from '@fortawesome/free-solid-svg-icons';
import Circles from '../../../assets/images/circle.png';
import axios from 'axios';
import { parse } from 'date-fns';


const CentralLoginDashboard = ({ loading, finYearFilter }) => {
  // Local state for Central Admin specific data
  const [dashboardData, setDashboardData] = useState({
    activeUsers: 0,
    chcCount: 0,
    smamChcCount: 0,
    fmttiCount: 0,
    crmDemoCount: 0,
    recordCount: 0,
    icarCount: 0
  });
  const [localLoading, setLocalLoading] = useState(false);
  const [moreInfoLoading, setMoreInfoLoading] = useState(false);

  // States for drill-down tables
  const [userVisible, setUserVisible] = useState(false);
  const [crmVisible, setCrmVisible] = useState(false);
  const [fmttiVisible, setFmttiVisible] = useState(false);
  const [smamVisible, setSmamVisible] = useState(false);
  const [crmDemoVisible, setCrmDemoVisible] = useState(false);
  const [apiDataReportVisible, setApiDataReportVisible] = useState(false);
  const [icarVisible, setIcarVisible] = useState(false);
  const [individualCrmSurveyVisible, setIndividualCrmSurveyVisible] = useState(false);
  const [individualSmamSurveyVisible, setIndividualSmamSurveyVisible] = useState(false);

  // States for detailed data
  const [userDetails, setUserDetails] = useState([]);
  const [crmChcDetails, setCrmChcDetails] = useState([]);
  const [fmttiStateDetails, setFmttiStateDetails] = useState([]);
  const [smamChcDetails, setSmamChcDetails] = useState([]);
  const [crmDemoDetails, setCrmDemoDetails] = useState([]);
  const [apiDataReportDetails, setApiDataReportDetails] = useState([]);
  const [icarDetails, setIcarDetails] = useState([]);
  const [individualCrmSurveyDetails, setIndividualCrmSurveyDetails] = useState([]);
  const [individualSmamSurveyDetails, setIndividualSmamSurveyDetails] = useState([]);
  const [selectedFinYear, setSelectedFinYear] = useState("");

  // States for drill-down expansions
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [expandedRowData, setExpandedRowData] = useState([]);
  const [expandedDistrictIndex, setExpandedDistrictIndex] = useState(null);
  const [expandedDistrictData, setExpandedDistrictData] = useState([]);
  const [expandedCrmStateIndex, setExpandedCrmStateIndex] = useState(null);
  const [expandedCrmStateDistrictData, setExpandedCrmStateDistrictData] = useState([]);
  const [expandedChcStateIndex, setExpandedChcStateIndex] = useState(null);
  const [expandedChcDistrictData, setExpandedChcDistrictData] = useState([]);
  const [expandedFmttiStateIndex, setExpandedFmttiStateIndex] = useState(null);
  const [expandedFmttiDistrictData, setExpandedFmttiDistrictData] = useState([]);
  const [expandedFmttiDistrictIndex, setExpandedFmttiDistrictIndex] = useState(null);
  const [expandedFmttiDistrictDetailsData, setExpandedFmttiDistrictDetailsData] = useState([]);
  const [expandedCrmDemoStateIndex, setExpandedCrmDemoStateIndex] = useState(null);
  const [expandedCrmDemoDistrictData, setExpandedCrmDemoDistrictData] = useState([]);
  const [expandedSmamChcStateIndex, setExpandedSmamChcStateIndex] = useState(null);
  const [expandedSmamChcDistrictData, setExpandedSmamChcDistrictData] = useState([]);
  const [expandedApiDataReportIndex, setExpandedApiDataReportIndex] = useState(null);
  const [expandedApiDataReportDistrictData, setExpandedApiDataReportDistrictData] = useState([]);
  const [loadingApiDataReportDistrict, setLoadingApiDataReportDistrict] = useState(false);
  const [expandedApiDataReportDistrictIndex, setExpandedApiDataReportDistrictIndex] = useState(null);
  const [expandedApiDataReportDistrictDetailsData, setExpandedApiDataReportDistrictDetailsData] = useState([]);
  const [expandedApiDataReportSubDistrictIndex, setExpandedApiDataReportSubDistrictIndex] = useState(null);
  const [expandedApiDataReportSubDistrictDetailsData, setExpandedApiDataReportSubDistrictDetailsData] = useState([]);
  const [expandedIcarAtariIndex, setExpandedIcarAtariIndex] = useState(null);
  const [expandedIndividualCrmIndex, setExpandedIndividualCrmIndex] = useState(null);
  const [expandedIndividualCrmDistrictData, setExpandedIndividualCrmDistrictData] = useState([]);
  const [loadingIndividualCrmDistrict, setLoadingIndividualCrmDistrict] = useState(false);
  const [expandedIndividualSmamIndex, setExpandedIndividualSmamIndex] = useState(null);
  const [expandedIndividualSmamDistrictData, setExpandedIndividualSmamDistrictData] = useState([]);
  const [loadingIndividualSmamDistrict, setLoadingIndividualSmamDistrict] = useState(false);
  const [expandedIcarKvkData, setExpandedIcarKvkData] = useState([]);
  const [loadingIcarKvk, setLoadingIcarKvk] = useState(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showImplementsModal, setShowImplementsModal] = useState(false);
  const [selectedImplements, setSelectedImplements] = useState(null);

  // Fetch CHC Count (CRM CHC)
  const fetchChcCount = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          "flag": "CHCCount",
          "userTypeCode": 2,
          "stateCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      // Fix: Check dataContent first as per your API response structure
      if (data.success && data.dataContent && data.dataContent.length > 0) {
        return parseInt(data.dataContent[0].total) || 0;
      } else if (data.success && data.total) {
        return parseInt(data.total.toString()) || 0;
      }
      return 0;
    } catch (error) {
      console.error('Error fetching CHC count:', error);
      return 0;
    }
  };

  // Handle CRM -> State -> District drill-down
  const handleCrmStateDistrictToggle = async (index, stateItem) => {
    console.log('handleCrmStateDistrictToggle called with:', { index, stateItem });
    if (expandedCrmStateIndex === index) {
      setExpandedCrmStateIndex(null);
      setExpandedCrmStateDistrictData([]);
    } else {
      setExpandedCrmStateIndex(index);
      try {
        const finYearForApi = formatFinYearForApi(finYearFilter);
        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
          {
            flag: "District",
            userTypeCode: 2,
            stateCode: parseInt(stateItem.stateCode || stateItem.districtCode, 10) || 0,
            finYear: finYearForApi
          },
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('CRM State District API response:', data);
        if (data.success && data.dataContent) {
          const transformedData = data.dataContent.map(item => ({
            districtCode: item.districtCode || 0,
            districtName: item.districtName || item.districtNames || 'N/A',
            totalUsers: parseInt(item.totalUsers || item.total || 0)
          }));
          console.log('Transformed CRM State district data:', transformedData);
          setExpandedCrmStateDistrictData(transformedData);
        } else {
          setExpandedCrmStateDistrictData([]);
        }
      } catch (error) {
        console.error('Error fetching CRM State district details:', error);
        setExpandedCrmStateDistrictData([]);
      }
    }
  };

  // Central Admin API calls configuration
  const apiConfig = [
    { key: 'smamChcCount', flag: 'CHCCount', userTypeCode: 3, endpoint: 'CentralDashBoardAll' },
    { key: 'fmttiCount', flag: 'Farmer', userTypeCode: 1, endpoint: 'CentralDashBoardAll' },
    { key: 'crmDemoCount', flag: 'Farmer', userTypeCode: 2, endpoint: 'CentralDashBoardAll' }
  ];

  // Helper: convert UI finYear (e.g. "2025-2026") to API format (e.g. "2025-26")
  const formatFinYearForApi = (uiFinYear) => {
    if (!uiFinYear || uiFinYear === "All") return "";
    const parts = String(uiFinYear).split("-");
    if (parts.length === 2 && parts[0].length === 4 && parts[1].length === 4) {
      const start = parts[0];
      const endShort = parts[1].slice(2); // "2026" -> "26"
      return `${start}-${endShort}`;
    }
    // Fallback: send as-is
    return uiFinYear;
  };

  // Fetch central dashboard summary (all top-card counts) from CentralDashBoardAll
  const fetchCentralDashboardSummary = async (uiFinYear) => {
    try {
      const finYearForApi = formatFinYearForApi(uiFinYear);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          flag: "Central",
          finYear: finYearForApi
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json"
          }
        }
      );

      if (data.success && Array.isArray(data.dataContent) && data.dataContent.length > 0) {
        const row = data.dataContent[0] || {};

        return {
          activeUsers: parseInt(row.totalUsers ?? 0, 10) || 0,
          chcCount: parseInt(row.crmCount ?? 0, 10) || 0,
          smamChcCount: parseInt(row.smamCount ?? 0, 10) || 0,
          fmttiCount: parseInt(row.fmttI_DemoCount ?? 0, 10) || 0,
          crmDemoCount: parseInt(row.crM_DemoCount ?? 0, 10) || 0,
          recordCount: parseInt(row.crmapiCount ?? 0, 10) || 0,
          icarCount: parseInt(row.icaR_MCOunt ?? 0, 10) || 0,
          crM_Individual: parseInt(row.crM_Individual ?? 0, 10) || 0,
          smaM_Individual: parseInt(row.smaM_Individual ?? 0, 10) || 0
        };
      }

      // Fallback: return zeroed summary if no data
      return {
        activeUsers: 0,
        chcCount: 0,
        smamChcCount: 0,
        fmttiCount: 0,
        crmDemoCount: 0,
        recordCount: 0,
        icarCount: 0
      };
    } catch (error) {
      console.error("Error fetching central dashboard summary:", error);
      return {
        activeUsers: 0,
        chcCount: 0,
        smamChcCount: 0,
        fmttiCount: 0,
        crmDemoCount: 0,
        recordCount: 0,
        icarCount: 0
      };
    }
  };

  // Fetch API Data Report count
  const fetchAPIDataReport = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
            "flag": "CRM_State_Temp",
            "finYear": formatFinYearForApi(finYearFilter)
          // "finYear": "",
          // "stateCode": 3,
          // "districtCode": 0,
          // "subdistrictCode": 0,
          // "userTypeCode": 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log('API Data Report Response:', data);
      
      let recordCount = 0;
      if (data && data.success) {
        // API returns recordCount at the top level
        if (data.recordCount !== undefined && data.recordCount !== null) {
          recordCount = parseInt(data.recordCount) || 0;
        } else if (data.dataContent && Array.isArray(data.dataContent)) {
          // Fallback: use dataContent length if recordCount is not available
          recordCount = data.dataContent.length;
        }
      }
      
      console.log('Extracted recordCount:', recordCount);
      return recordCount;
    } catch (error) {
      console.error('Error fetching API Data Report count:', error);
      return 0;
    }
  };

  // Generic API call function for other endpoints
  const fetchData = async (config) => {
    try {
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/${config.endpoint}`,
        {
          flag: config.flag,
          userTypeCode: config.userTypeCode,
          stateCode: 0
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );
      
      let count = 0;
      if (data.success) {
        // Normalize count field from various API shapes
        if (data.dataContent && data.dataContent.length > 0) {
          const row = data.dataContent[0] || {};
          const totalValue =
            row.total ??
            row.count ??
            row.totalUsers ??
            row.totalFarmers ??
            row.recordCount ??
            0;
          count = parseInt(String(totalValue)) || 0;
        } else if (
          data.total !== undefined ||
          data.count !== undefined ||
          data.totalUsers !== undefined ||
          data.totalFarmers !== undefined ||
          data.recordCount !== undefined
        ) {
          const totalValue =
            data.total ??
            data.count ??
            data.totalUsers ??
            data.totalFarmers ??
            data.recordCount ??
            0;
          count = parseInt(String(totalValue)) || 0;
        }
      }
      
      return count;
    } catch (error) {
      console.error(`Error fetching ${config.flag} count:`, error);
      return 0;
    }
  };

  // Fetch all dashboard data (top cards)
  const fetchDashboardData = async () => {
    setLocalLoading(true);
    try {
      const summary = await fetchCentralDashboardSummary(finYearFilter);
      setDashboardData(summary);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
    } finally {
      setLocalLoading(false);
    }
  };

  // Fetch detailed user data
  const fetchUserDetails = async () => {
    try {
      const finYearForApi = formatFinYearForApi(finYearFilter);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`,
        {
          "flag": "UserType",
          "userTypeCode": 0,
          "stateCode": 0,
          "finYear": finYearForApi
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (data.success && data.dataContent) {
        setUserDetails(data.dataContent);
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
      setUserDetails([]);
    }
  };

  // Handle More Info clicks
  const handleMoreInfoClick = async (type) => {
    try {
      setMoreInfoLoading(true);
      const actionType = String(type).toLowerCase();
      
      // Reset expanded states
      setExpandedRowIndex(null);
      setExpandedRowData([]);
      setExpandedDistrictIndex(null);
      setExpandedDistrictData([]);
      setExpandedCrmStateIndex(null);
      setExpandedCrmStateDistrictData([]);
      setExpandedApiDataReportIndex(null);
      setExpandedApiDataReportDistrictData([]);
      setExpandedApiDataReportDistrictIndex(null);
      setExpandedApiDataReportDistrictDetailsData([]);
      setExpandedApiDataReportSubDistrictIndex(null);
      setExpandedApiDataReportSubDistrictDetailsData([]);

      // Reset all visibility states
      setUserVisible(false);
      setCrmVisible(false);
      setFmttiVisible(false);
      setSmamVisible(false);
      setCrmDemoVisible(false);
      setApiDataReportVisible(false);
      setIcarVisible(false);
      setIndividualCrmSurveyVisible(false);
      setIndividualSmamSurveyVisible(false);

      // Set visibility and fetch data based on type
      switch (actionType) {
        case 'user':
          await fetchUserDetails();
          setUserVisible(true);
          break;
        case 'crm':
          await fetchCHCDetails();
          setCrmVisible(true);
          break;
        case 'fmtti':
          await fetchFMTTIDetails();
          setFmttiVisible(true);
          break;
        case 'smam':
          await fetchSMAMCHCDetails();
          setSmamVisible(true);
          break;
        case 'crmdemo':
          await fetchCRMDemoDetails();
          setCrmDemoVisible(true);
          break;
        case 'apidatareport':
          await fetchAPIDataReportDetails(selectedFinYear);
          setApiDataReportVisible(true);
          break;
        case 'icar':
          await fetchIcarDetails();
          setIcarVisible(true);
          break;
        case 'individualcrmsurvey':
          await fetchIndividualCrmSurveyDetails();
          setIndividualCrmSurveyVisible(true);
          break;
        case 'individualsmamsurvey':
          await fetchIndividualSmamSurveyDetails();
          setIndividualSmamSurveyVisible(true);
          break;
        default:
          break;
      }

      // Scroll to the table after a short delay to ensure it's rendered
      setTimeout(() => {
        const tableId = `${type}-details-table`;
        const tableElement = document.getElementById(tableId);
        if (tableElement) {
          tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } catch (error) {
      console.error(`Error handling More Info click for ${type}:`, error);
    } finally {
      setMoreInfoLoading(false);
    }
  };

  // Fetch CHC Details (Establish CRM CHC More Info) via CentralDashBoardAll with flag EXP_CRM_State
  const fetchCHCDetails = async () => {
    try {
      const finYearForApi = formatFinYearForApi(finYearFilter);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          flag: "CRM_State",
          finYear: finYearForApi
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json"
          }
        }
      );

      if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName ?? item.districtNames ?? "N/A",
          total: parseInt(item.total ?? item.count ?? item.crmCount ?? 0, 10) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames
        }));
        setCrmChcDetails(transformedData);
      } else {
        setCrmChcDetails([]);
      }
    } catch (error) {
      console.error("Error fetching CHC details:", error);
      setCrmChcDetails([]);
    }
  };

  // Fetch FMTTI Details
  const fetchFMTTIDetails = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          "flag": "FMTTI_Instute_M_Demo",
          "finYear": formatFinYearForApi(finYearFilter),
         
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
        const transformedData = data.dataContent.map(item => ({
          fmttI_Name: item.fmttI_Name,
          fmttiCode: item.fmttiCode,
          stateCode: item.stateCode,
          stateName: item.stateName ?? item.districtNames ?? "N/A",
          total: parseInt(item.total ?? item.totalFarmers ?? 0, 10) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames
        }));
        setFmttiStateDetails(transformedData);
      } else {
        setFmttiStateDetails([]);
      }
    } catch (error) {
      console.error('Error fetching FMTTI details:', error);
      setFmttiStateDetails([]);
    }
  };

  // Fetch SMAM CHC Details
  const fetchSMAMCHCDetails = async () => {
    try {
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          "flag": "CRM_State_SMAM",
          "finYear": formatFinYearForApi(finYearFilter)
        },
        {
          headers: {
            'accept': '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      if (data.success && data.dataContent) {
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName,
          total: parseInt(item.total) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames
        }));
        
        setSmamChcDetails(transformedData);
      }
    } catch (error) {
      console.error('Error fetching SMAM CHC details:', error);
      setSmamChcDetails([]);
    }
  };

  // Fetch CRM Machine Demonstration Details via CentralDashBoardAll with flag CRM_State_M_Demo
  const fetchCRMDemoDetails = async () => {
    try {
      const finYearForApi = formatFinYearForApi(finYearFilter);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          flag: "CRM_State_M_Demo",
          finYear: finYearForApi
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json"
          }
        }
      );

      if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName ?? item.districtNames ?? "N/A",
          total: parseInt(item.total ?? item.count ?? item.totalFarmers ?? 0, 10) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames
        }));
        setCrmDemoDetails(transformedData);
      } else {
        setCrmDemoDetails([]);
      }
    } catch (error) {
      console.error("Error fetching CRM Demo details:", error);
      setCrmDemoDetails([]);
    }
  };

  // Fetch ICAR Details via CentralDashBoardAll with flag Atari
  const fetchIcarDetails = async () => {
    try {
      const finYearForApi = formatFinYearForApi(finYearFilter);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          flag: "Atari",
          finYear: finYearForApi
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json"
          }
        }
      );

      if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName ?? item.districtNames ?? "N/A",
          total: parseInt(item.total ?? item.count ?? item.totalFarmers ?? 0, 10) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          atari_Name: item.atari_Name,
          atariCode: item.atariCode,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames
        }));
        setIcarDetails(transformedData);
      } else {
        setIcarDetails([]);
      }
    } catch (error) {
      console.error("Error fetching ICAR details:", error);
      setIcarDetails([]);
    }
  };

  const fetchIndividualCrmSurveyDetails = async () => {
    try {
      const finYearForApi = formatFinYearForApi(finYearFilter);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          flag: "EXP_CRM_State",
          finYear: finYearForApi
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json"
          }
        }
      );

      if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName ?? item.districtNames ?? "N/A",
          total: parseInt(item.total ?? item.count ?? item.totalFarmers ?? 0, 10) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames,
          crM_Individual: item.crM_Individual,
          smaM_Individual: item.smaM_Individual
        }));
        setIndividualCrmSurveyDetails(transformedData);
      } else {
        setIndividualCrmSurveyDetails([]);
      }
    } catch (error) {
      console.error("Error fetching Individual CRM survey details:", error);
      setIndividualCrmSurveyDetails([]);
    }
  };

  const fetchIndividualSmamSurveyDetails = async () => {
    try {
      const finYearForApi = formatFinYearForApi(finYearFilter);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          flag: "EXP_SMAM_State",
          finYear: finYearForApi
        },
        {
          headers: {
            accept: "*/*",
            "Content-Type": "application/json"
          }
        }
      );

      if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
        const transformedData = data.dataContent.map(item => ({
          stateCode: item.stateCode,
          stateName: item.stateName ?? item.districtNames ?? "N/A",
          total: parseInt(item.total ?? item.count ?? item.totalFarmers ?? 0, 10) || 0,
          flag: item.flag,
          createdBy: item.createdBy,
          userTypeCode: item.userTypeCode,
          totalFarmers: item.totalFarmers,
          districtCode: item.districtCode,
          districtNames: item.districtNames,
          crM_Individual: item.crM_Individual,
          smaM_Individual: item.smaM_Individual
        }));
        setIndividualSmamSurveyDetails(transformedData);
      } else {
        setIndividualSmamSurveyDetails([]);
      }
    } catch (error) {
      console.error("Error fetching Individual SMAM survey details:", error);
      setIndividualSmamSurveyDetails([]);
    }
  };
  // Fetch API Data Report Details via CentralDashBoardAll with flag CRM_State_temp
  const fetchAPIDataReportDetails = async (finYear = "") => {
    try {
      const finYearForApi = formatFinYearForApi(finYear || finYearFilter);
      const { data } = await axios.post(
        `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
        {
          flag: "CRM_State_temp",
          finYear: finYearForApi,
          stateCode: 0
        },
        {
          headers: {
            accept: '*/*',
            'Content-Type': 'application/json'
          }
        }
      );

      console.log('API Data Report Details Response:', data);

      if (data && data.success && data.dataContent && Array.isArray(data.dataContent)) {
        // Map data directly - each item has stateName, stateCode, and total (count)
        const transformedData = data.dataContent.map(item => ({
          stateName: item.stateName ?? 'N/A',
          stateCode: item.stateCode ?? 0,
          total: parseInt(item.total ?? 0, 10) || 0,
          recordCount: parseInt(item.total ?? 0, 10) || 0
        }));
        
        console.log('Transformed API Data Report Details:', transformedData);
        setApiDataReportDetails(transformedData);
      } else {
        console.log('No data content found in response');
        setApiDataReportDetails([]);
      }
    } catch (error) {
      console.error('Error fetching API Data Report details:', error);
      setApiDataReportDetails([]);
    }
  };

  // Handle Financial Year change
  const handleFinYearChange = async (e) => {
    const selectedYear = e.target.value;
    setSelectedFinYear(selectedYear);
    // Reset expanded states
    setExpandedApiDataReportIndex(null);
    setExpandedApiDataReportDistrictData([]);
    setExpandedApiDataReportDistrictIndex(null);
    setExpandedApiDataReportDistrictDetailsData([]);
    setExpandedApiDataReportSubDistrictIndex(null);
    setExpandedApiDataReportSubDistrictDetailsData([]);
    // Fetch data with selected year
    await fetchAPIDataReportDetails(selectedYear);
  };

  // Handle API Data Report state/district toggle
  const handleApiDataReportToggle = async (index, stateItem) => {
    console.log('handleApiDataReportToggle called with:', { index, stateItem });
    if (expandedApiDataReportIndex === index) {
      setExpandedApiDataReportIndex(null);
      setExpandedApiDataReportDistrictData([]);
      setExpandedApiDataReportDistrictIndex(null);
      setExpandedApiDataReportDistrictDetailsData([]);
      setLoadingApiDataReportDistrict(false);
    } else {
      setExpandedApiDataReportIndex(index);
      setExpandedApiDataReportDistrictIndex(null);
      setExpandedApiDataReportDistrictDetailsData([]);
      setLoadingApiDataReportDistrict(true);
      setExpandedApiDataReportDistrictData([]);
      try {
        const finYearForApi = formatFinYearForApi(finYearFilter);
        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          {
            flag: "CRM_District_temp",
            finYear: finYearForApi,
            stateCode: parseInt(stateItem.stateCode) || 0
          },
          {
            headers: {
              accept: '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('API Data Report District Response:', data);

        if (data && data.success && data.dataContent && Array.isArray(data.dataContent)) {
          // Map data directly - each item has districtNames, districtCode, and total (count)
          const transformedData = data.dataContent.map(item => ({
            districtName: item.districtNames ?? item.districtName ?? 'N/A',
            districtCode: item.districtCode ?? 0,
            recordCount: parseInt(item.total ?? 0, 10) || 0
          }));
          
          console.log('Transformed API Data Report District Details:', transformedData);
          setExpandedApiDataReportDistrictData(transformedData);
        } else {
          console.log('No district data content found in response');
          setExpandedApiDataReportDistrictData([]);
        }
      } catch (error) {
      console.error('Error fetching API Data Report district details:', error);
      setExpandedApiDataReportDistrictData([]);
      } finally {
        setLoadingApiDataReportDistrict(false);
      }
    }
  };

  // Handle API Data Report district/block toggle
  const handleApiDataDistrictReportToggle = async (index, districtItem, stateItem) => {
    console.log('handleApiDataDistrictReportToggle called with:', { index, districtItem, stateItem });
    if (expandedApiDataReportDistrictIndex === index) {
      setExpandedApiDataReportDistrictIndex(null);
      setExpandedApiDataReportDistrictDetailsData([]);
    } else {
      setExpandedApiDataReportDistrictIndex(index);
      try {
        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          {
            "flag": "CRM_District_temp",
            "finYear": formatFinYearForApi(finYearFilter),
            "stateCode": parseInt(stateItem.stateCode) || 0
            // "finYear": selectedFinYear || "",
            // "stateCode": parseInt(stateItem.stateCode) || 0,
            // "districtCode": parseInt(districtItem.districtCode) || 0,
            // "subdistrictCode": 0,
            // "userTypeCode": 0 
          },
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('API Data Report Block Response:', data);

        if (data && data.success && data.dataContent && Array.isArray(data.dataContent)) {
          // Group data by block/subdistrict and count records per block
          const blockGroupMap = {};
          
          data.dataContent.forEach((item) => {
            const blockName = item.subdistrictName || item.blockName || 'N/A';
            const blockCode = item.subdistrictCode || item.blockCode || 0;
            
            if (!blockGroupMap[blockName]) {
              blockGroupMap[blockName] = {
                blockName: blockName,
                blockCode: blockCode,
                recordCount: 0
              };
            }
            blockGroupMap[blockName].recordCount += 1;
          });
          
          // Convert map to array
          const transformedData = Object.values(blockGroupMap);
          
          console.log('Transformed API Data Report Block Details:', transformedData);
          setExpandedApiDataReportDistrictDetailsData(transformedData);
        } else {
          console.log('No block data content found in response');
          setExpandedApiDataReportDistrictDetailsData([]);
        }
      } catch (error) {
      console.error('Error fetching API Data Report block details:', error);
      setExpandedApiDataReportDistrictDetailsData([]);
      }
    }
  };

  // Handle API Data Report subdistrict/village toggle
  const handleApiDataSubDistrictReportToggle = async (index, subDistrictItem, districtItem, stateItem) => {
    console.log('handleApiDataSubDistrictReportToggle called with:', { index, subDistrictItem, districtItem, stateItem });
    if (expandedApiDataReportSubDistrictIndex === index) {
      setExpandedApiDataReportSubDistrictIndex(null);
      setExpandedApiDataReportSubDistrictDetailsData([]);
    } else {
      setExpandedApiDataReportSubDistrictIndex(index);
      try {
        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          {
            // "finYear": selectedFinYear || "",
            // "stateCode": parseInt(stateItem.stateCode) || 0,
            // "districtCode": parseInt(districtItem.districtCode) || 0,
            // "subdistrictCode": parseInt(subDistrictItem.blockCode || subDistrictItem.subdistrictCode) || 0,
            // "userTypeCode": 0 
                "flag": "CRM_District_temp",
    "finYear": "",
    "stateCode": 3
          },
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('API Data Report SubDistrict/Village Response:', data);

        if (data && data.success && data.dataContent && Array.isArray(data.dataContent)) {
          // Store the raw data or group by village if needed
          // For now, we'll show all records for this subdistrict
          const transformedData = data.dataContent.map((item, idx) => ({
            id: item.chcId || item.id || idx + 1,
            chcName: item.chcName || 'N/A',
            villageName: item.villageName || 'N/A',
            recordCount: 1,
            ...item
          }));
          
          console.log('Transformed API Data Report SubDistrict Details:', transformedData);
          setExpandedApiDataReportSubDistrictDetailsData(transformedData);
        } else {
          console.log('No subdistrict/village data content found in response');
          setExpandedApiDataReportSubDistrictDetailsData([]);
        }
      } catch (error) {
        console.error('Error fetching API Data Report subdistrict details:', error);
        setExpandedApiDataReportSubDistrictDetailsData([]);
      }
    }
  };

  // Handle district toggle for SMAM CHC
  const handleSmamChcDistrictToggle = async (index, stateItem) => {
    console.log('handleSmamChcDistrictToggle called with:', { index, stateItem });
    if (expandedDistrictIndex === index) {
      setExpandedDistrictIndex(null);
      setExpandedDistrictData([]);
    } else {
      setExpandedDistrictIndex(index);
      try {
        const apiPayload = {
          flag: "CRM_District_SMAM",
          finYear: formatFinYearForApi(finYearFilter),
          stateCode: parseInt(stateItem.stateCode) || 0
        };
        console.log('SMAM CHC District API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('SMAM CHC District API response:', data);
        if (data.success && data.dataContent) {
          const transformedData = data.dataContent.map(item => ({
            districtCode: item.districtCode,
            districtNames: item.districtNames,
            totalUsers: parseInt(item.totalUsers || item.total || 0)
          }));
          console.log('Transformed SMAM CHC district data:', transformedData);
          setExpandedDistrictData(transformedData);
        }
      } catch (error) {
        console.error('Error fetching SMAM CHC district details:', error);
        setExpandedDistrictData([]);
      }
    }
  };

  // Handle district toggle for FMTTI Demonstration (state → district) via CentralDashBoardAll
  // Handle state toggle for FMTTI Demonstration (institute → state)
  const handleFmttiDemonstrationStateToggle = async (index, instituteItem) => {
    console.log('handleFmttiDemonstrationStateToggle called with:', { index, instituteItem });
    if (expandedFmttiStateIndex === index) {
      setExpandedFmttiStateIndex(null);
      setExpandedFmttiDistrictData([]);
      setExpandedFmttiDistrictIndex(null);
      setExpandedFmttiDistrictDetailsData([]);
    } else {
      setExpandedFmttiStateIndex(index);
      setExpandedFmttiDistrictIndex(null);
      setExpandedFmttiDistrictDetailsData([]);
      try {
        const finYearForApi = formatFinYearForApi(finYearFilter);
        const apiPayload = {
          flag: "FMTTI_Inst_State_M_Demo",
          finYear: finYearForApi,
          fmttiCode: parseInt(instituteItem.fmttiCode)
        };
        console.log('FMTTI Demonstration State API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          apiPayload,
          {
            headers: {
              accept: '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('FMTTI Demonstration State API response:', data);
        if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
          const transformedData = data.dataContent.map(item => ({
            stateCode: item.stateCode,
            stateName: item.stateName,
            fmttiCode: item.fmttiCode,
            total: parseInt(item.total ?? 0, 10)
          }));
          console.log('Transformed FMTTI Demonstration state data:', transformedData);
          setExpandedFmttiDistrictData(transformedData);
        } else {
          setExpandedFmttiDistrictData([]);
        }
      } catch (error) {
        console.error('Error fetching FMTTI Demonstration state details:', error);
        setExpandedFmttiDistrictData([]);
      }
    }
  };

  // Handle district toggle for FMTTI Demonstration (state → district)
  const handleFmttiDemonstrationDistrictToggle = async (stateIndex, stateItem) => {
    console.log('handleFmttiDemonstrationDistrictToggle called with:', { stateIndex, stateItem });
    if (expandedFmttiDistrictIndex === stateIndex) {
      setExpandedFmttiDistrictIndex(null);
      setExpandedFmttiDistrictDetailsData([]);
    } else {
      setExpandedFmttiDistrictIndex(stateIndex);
      try {
        const finYearForApi = formatFinYearForApi(finYearFilter);
        const apiPayload = {
          flag: "FMTTI_Inst_District_M_Demo",
          finYear: finYearForApi,
          stateCode: parseInt(stateItem.stateCode),
          fmttiCode: parseInt(stateItem.fmttiCode) 
                };
        console.log('FMTTI Demonstration District API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          apiPayload,
          {
            headers: {
              accept: '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('FMTTI Demonstration District API response:', data);
        if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
          const transformedData = data.dataContent.map(item => ({
            stateCode: item.stateCode,
            stateName: item.stateName || 'N/A',
            districtCode: item.districtCode,
            districtNames: item.districtNames ?? item.districtName ?? 'N/A',
            total: parseInt(item.total ?? 0, 10) || 0
          }));
          console.log('Transformed FMTTI Demonstration district data:', transformedData);
          setExpandedFmttiDistrictDetailsData(transformedData);
        } else {
          setExpandedFmttiDistrictDetailsData([]);
        }
      } catch (error) {
        console.error('Error fetching FMTTI Demonstration district details:', error);
        setExpandedFmttiDistrictDetailsData([]);
      }
    }
  };

  // Handle district toggle for CRM Demonstration (state → district)
  const handleCrmDemoDistrictToggle = async (index, stateItem) => {
    console.log('handleCrmDemoDistrictToggle called with:', { index, stateItem });
    if (expandedCrmDemoStateIndex === index) {
      setExpandedCrmDemoStateIndex(null);
      setExpandedCrmDemoDistrictData([]);
    } else {
      setExpandedCrmDemoStateIndex(index);
      try {
        const apiPayload = {
          flag: "CRM_District_M_Demo",
          finYear: formatFinYearForApi(finYearFilter),
          stateCode: parseInt(stateItem.stateCode)
        };
        console.log('CRM Demonstration District API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('CRM Demonstration District API response:', data);
        if (data.success && data.dataContent) {
          const transformedData = data.dataContent.map(item => ({
            districtCode: item.districtCode,
            districtNames: item.districtNames || item.districtName || 'N/A',
            totalFarmers: parseInt(item.totalFarmers || item.total || item.totalUsers || 0)
          }));
          console.log('Transformed CRM Demonstration district data:', transformedData);
          setExpandedCrmDemoDistrictData(transformedData);
        } else {
          setExpandedCrmDemoDistrictData([]);
        }
      } catch (error) {
        console.error('Error fetching CRM Demonstration district details:', error);
        setExpandedCrmDemoDistrictData([]);
      }
    }
  };

  // Handle ICAR Atari -> KVK drill-down
  const handleIcarAtariToggle = async (index, atariItem) => {
    console.log('handleIcarAtariToggle called with:', { index, atariItem });
    if (expandedIcarAtariIndex === index) {
      setExpandedIcarAtariIndex(null);
      setExpandedIcarKvkData([]);
    } else {
      setExpandedIcarAtariIndex(index);
      setLoadingIcarKvk(true);
      try {
        const apiPayload = {
          flag: "KVKWise",
          finYear: formatFinYearForApi(finYearFilter),
          atariCode: parseInt(atariItem.atariCode)
        };
        console.log('ICAR KVK API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('ICAR KVK API response:', data);
        if (data.success && data.dataContent) {
          const transformedData = data.dataContent.map(item => ({
            kvkCode: item.kvkCode,
            kvkName: item.kvK_Name || item.kvkName || 'N/A',
            total: parseInt(item.total || item.count || item.totalUsers || 0, 10) || 0
          }));
          console.log('Transformed ICAR KVK data:', transformedData);
          setExpandedIcarKvkData(transformedData);
        } else {
          setExpandedIcarKvkData([]);
        }
      } catch (error) {
        console.error('Error fetching ICAR KVK details:', error);
        setExpandedIcarKvkData([]);
      } finally {
        setLoadingIcarKvk(false);
      }
    }
  };

  // Handle district toggle for CRM CHC
  const handleChcDistrictToggle = async (index, stateItem) => {
    console.log('handleChcDistrictToggle called with:', { index, stateItem });
    if (expandedDistrictIndex === index) {
      setExpandedDistrictIndex(null);
      setExpandedDistrictData([]);
    } else {
      setExpandedDistrictIndex(index);
      try {
        const finYearForApi = formatFinYearForApi(finYearFilter);
        const apiPayload = {
          flag: "CRM_District",
          finYear: finYearForApi,
          stateCode: parseInt(stateItem.stateCode) || 0
        };
        console.log('CHC District API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('CHC District API response:', data);
        if (data.success && data.dataContent) {
          const transformedData = data.dataContent.map(item => ({
            districtCode: item.districtCode,
            districtNames: item.districtNames,
            totalUsers: parseInt(item.totalUsers || item.total || 0)
          }));
          console.log('Transformed CHC district data:', transformedData);
          setExpandedDistrictData(transformedData);
        }
      } catch (error) {
        console.error('Error fetching CHC district details:', error);
        setExpandedDistrictData([]);
      }
    }
  };

  // Handle district toggle for Active Users
  const handleActiveUserDistrictToggle = async (index, stateItem, userType) => {
   console.log('handleActiveUserDistrictToggle called with:', { index, stateItem, userType });
   if (expandedDistrictIndex === index) {
     setExpandedDistrictIndex(null);
     setExpandedDistrictData([]);
     setExpandedCrmStateIndex(null);
     setExpandedCrmStateDistrictData([]);
   } else {
     setExpandedDistrictIndex(index);
     setExpandedCrmStateIndex(null);
     setExpandedCrmStateDistrictData([]);
      try {
        // Check if user is FMTTI / CRM / SMAM - use different endpoint and payload
        const isFMTTI = userType === "FMTTI" || userType === "Fmtti";
        const isCRM = userType === "CRM" || userType === "crm";
        const isSMAM = userType === "SMAM" || userType === "smam";
        const finYearForApi = formatFinYearForApi(finYearFilter);
        
        let apiEndpoint;
        let apiPayload;

        if (isFMTTI) {
          // Use different endpoint and payload for FMTTI
          apiEndpoint = `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetFMTTIDashboarReportCount`;
          const fmttiCode = parseInt(stateItem.fmttiCode || stateItem.userRoleCode, 10) || 0;
          apiPayload = {
            flag: "UserRole",
            fmttiCode: parseInt(stateItem.fmttiCode || fmttiCode || 0, 10),
            finYear: finYearForApi
          };
        } else {
          // Use existing endpoint and payload for SMAM and CRM
          console.log('stateItem.category:', stateItem.category);
          const categoryUpper = (stateItem.category || "").toUpperCase();
          const isStateCategory = isCRM && categoryUpper === "STATE";
          const isIcarCategory = isCRM && (categoryUpper === "ICAR" || categoryUpper === "ICARDETAIL");

          // All CRM and SMAM use GetDashboarReportCount endpoint
          apiEndpoint = `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`;

          if (isIcarCategory) {
            // For ICAR/ICARDETAIL, use ICARDETAIL flag
            apiPayload = {
              flag: "ICARDETAIL",
              userTypeCode: 0,
              stateCode: 0,
              finYear: finYearForApi
            };
          } else if (isStateCategory) {
            // For STATE category, use State flag
            apiPayload = {
              flag: "State",
              userTypeCode: 2,
              stateCode: 0,
              finYear: finYearForApi
            };
          } else if (isSMAM) {
            // For SMAM, use District flag and pass clicked state's stateCode
            apiPayload = {
              flag: "District",
              userTypeCode: 3,
              stateCode: parseInt(stateItem.stateCode, 10) || 0,
              finYear: finYearForApi
            };
          } 
        }
        
        console.log('Active User District API Payload:', apiPayload);

        const { data } = await axios.post(
          apiEndpoint,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('Active User District API response:', data);
        if (data.success && data.dataContent) {
          // Check if this is ICAR/ATARI data
          const categoryUpper = (stateItem.category || "").toUpperCase();
          const isIcarCategory = isCRM && (categoryUpper === "ICAR" || categoryUpper === "ICARDETAIL");
          
          const transformedData = data.dataContent.map(item => ({
            stateCode: item.stateCode || 0,
            districtCode: item.districtCode || item.stateCode || 0,
            atariCode: item.atariCode || 0,
            // Prefer explicit district fields, but fall back gracefully for other shapes
            districtNames: item.districtNames || item.districtName || item.stateName || item.atari_Name || item.userRoleName || 'N/A',
            totalUsers: parseInt(item.totalUsers || item.total || 0),
            userRoleName: item.userRoleName,
            fmttiCode: item.fmttiCode,
            fmttI_Name: item.fmttI_Name,
            atari_Name: item.atari_Name
          }));
          console.log('Transformed Active User district data:', transformedData);
          setExpandedDistrictData(transformedData);
        }
      } catch (error) {
        console.error('Error fetching Active User district details:', error);
        setExpandedDistrictData([]);
      }
    }
  };

  // Handle row toggle for FMTTI Demonstration
  const handleRowToggleDemonstration = async (index, user) => {
    console.log('handleRowToggleDemonstration called with:', { index, user });
    if (expandedRowIndex === index) {
      setExpandedRowIndex(null);
      setExpandedRowData([]);
    } else {
      setExpandedRowIndex(index);
      try {
        // Get the state item from fmttiStateDetails
        const stateItem = fmttiStateDetails[index];
        if (!stateItem) {
          console.error('State item not found for index:', index);
          return;
        }

        const finYearForApi = formatFinYearForApi(finYearFilter);
        const apiPayload = {
          flag: "FarmerD",
          userTypeCode: 1,
          stateCode: parseInt(stateItem.stateCode) || 0,
          finYear: finYearForApi
        };
        console.log('FMTTI Demonstration API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('FMTTI Demonstration API response:', data);
        if (data.success && data.dataContent) {
          const transformedData = data.dataContent.map(item => ({
            districtCode: item.districtCode,
            districtNames: item.districtNames,
            total: parseInt(item.total || item.totalFarmers || 0)
          }));
          console.log('Transformed FMTTI Demonstration data:', transformedData);
          setExpandedRowData(transformedData);
        } else {
          setExpandedRowData([]);
        }
      } catch (error) {
        console.error('Error fetching FMTTI Demonstration details:', error);
        setExpandedRowData([]);
      }
    }
  };

  // Handle row toggle for drill-down
  const handleRowToggle = async (index, user) => {
    console.log('handleRowToggle called with:', { index, user });
    if (expandedRowIndex === index) {
      setExpandedRowIndex(null);
      setExpandedRowData([]);
      setExpandedDistrictIndex(null);
      setExpandedDistrictData([]);
    } else {
      setExpandedRowIndex(index);
      setExpandedDistrictIndex(null);
      setExpandedDistrictData([]);
      setExpandedCrmStateIndex(null);
      setExpandedCrmStateDistrictData([]);
      try {
        // Check which top-level role row is clicked (FMTTI / CRM / SMAM)
        const isFMTTI = user.userTypeName === "FMTTI" || user.userTypeName === "Fmtti";
        const isCRM = user.userTypeName === "CRM" || user.userTypeName === "crm";
        const isSMAM = user.userTypeName === "SMAM" || user.userTypeName === "smam";

        let apiEndpoint;
        let apiPayload;

        const finYearForApi = formatFinYearForApi(finYearFilter);
        
        if (isFMTTI) {
          // FMTTI uses a separate dashboard API
          apiEndpoint = `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetFMTTIDashboarReportCount`;
          apiPayload = {
            flag: "FMTTI",
            fmttiCode: parseInt(user.fmttiCode || user.userRoleCode, 10) || 0,
            finYear: finYearForApi
          };
        } else if (isCRM) {
          // CRM: fetch ICAR / State categories
          apiEndpoint = `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`;
          apiPayload = {
            flag: "CRMUserTyp",
            userTypeCode: 2,
            stateCode: 0,
            finYear: finYearForApi
          };
        } else if (isSMAM) {
          // SMAM: fetch state list using State flag
          apiEndpoint = `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/GetDashboarReportCount`;
          apiPayload = {
            flag: "State",
            userTypeCode: 3,
            stateCode: 0,
            finYear: finYearForApi
          };
        } else {
          // Fallback (should not normally happen)
          apiEndpoint = `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`;
          apiPayload = {
            flag: "CRMUserTyp",
            userTypeCode: 2,
            stateCode: 0,
            finYear: finYearForApi
          };
        }

        const { data } = await axios.post(
          apiEndpoint,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('Row toggle API response:', data);
        if (data.success && data.dataContent) {
          const transformedData = data.dataContent.map(item => ({
            stateCode: item.stateCode,
            stateName: item.stateName || item.userRoleName || 'N/A',
            roleName: item.roleName || item.userRoleName || item.stateName || 'N/A',
            userRoleName: item.userRoleName || item.roleName || item.stateName || 'N/A',
            fmttI_Name: item.fmttI_Name || 'N/A',
            totalUsers: parseInt(item.totalUsers || item.total || 0),
            userCount: parseInt(item.userCount || 0),
            userTypeName: user.userTypeName,
            fmttiCode: parseInt(item.fmttiCode || item.userRoleCode, 10) || 0,
            userRoleCode: item.userRoleCode,
            category: item.category || 'N/A'
          }));
          console.log('Transformed row data:', transformedData);
          setExpandedRowData(transformedData);
        }
      } catch (error) {
        console.error('Error fetching row details:', error);
        setExpandedRowData([]);
      }
    }
  };

  // Export functions
  const getDistrictLabel = (item) =>
    item?.districtNames ?? item?.districtName ?? item?.DistrictName ?? 'N/A';

  const escapeCsvValue = (value) =>
    `"${String(value ?? '').replace(/"/g, '""')}"`;

  const getExportCellValue = (item, header) => {
    const h = header.trim();
    const countValue =
      item?.totalUsers ??
      item?.total ??
      item?.totalFarmers ??
      item?.recordCount ??
      item?.count ??
      0;

    switch (h) {
      case 'State':
      case 'State Name':
      case 'stateName':
        return item?.stateName ?? 'N/A';
      case 'District Name':
      case 'District':
        return getDistrictLabel(item);
      case 'Sub District Name':
        return item?.blockName ?? item?.subDistrictName ?? item?.subdistrictName ?? 'N/A';
      case 'Role Name':
      case 'Role':
        return item?.userTypeName ?? item?.userRoleName ?? item?.roleName ?? 'N/A';
      case 'Atari Name':
      case 'ATARI Name':
        return item?.atari_Name ?? item?.atariName ?? item?.districtNames ?? 'N/A';
      case 'KVK Name':
        return item?.kvK_Name ?? item?.kvkName ?? item?.kvk_Name ?? 'N/A';
      case 'CHC Name':
        return item?.name ?? item?.chcName ?? 'N/A';
      case 'CHC ID':
        return item?.id ?? item?.chcId ?? 'N/A';
      case 'Village Name':
        return item?.villageName ?? 'N/A';
      case 'No of Users':
      case 'User Count':
      case 'Count':
      case 'Record Count':
      case 'total':
        return countValue;
      default:
        break;
    }

    if (item && item[h] !== undefined && item[h] !== null && item[h] !== '') {
      return item[h];
    }

    const normalizedHeader = h.toLowerCase().replace(/\s+/g, '');
    const matchedKey = item
      ? Object.keys(item).find((key) => key.toLowerCase() === normalizedHeader)
      : undefined;

    if (matchedKey && item[matchedKey] !== undefined && item[matchedKey] !== null && item[matchedKey] !== '') {
      return item[matchedKey];
    }

    return 'N/A';
  };

  const exportToCSV = (data, filename, headers) => {
    if (!data || data.length === 0) {
      alert("No data available to export.");
      return;
    }

    const csvRows = [headers.join(",")];
    data.forEach((item, index) => {
      const row = [
        index + 1,
        ...headers.slice(1).map((header) => escapeCsvValue(getExportCellValue(item, header))),
      ];
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");
    const blob = new Blob(['\uFEFF' + csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Handle image view
  const handleImageView = (imagePath) => {
    if (imagePath) {
      setSelectedImageUrl(imagePath);
      setShowImageModal(true);
    }
  };

  // Close image modal
  const handleCloseImageModal = () => {
    setShowImageModal(false);
    setSelectedImageUrl(null);
  };

  // Handle implement details view
  const handleImplementsClick = (chc) => {
    if (chc && chc.noOfImplements > 0) {
      setSelectedImplements(chc);
      setShowImplementsModal(true);
    }
  };

  // Close implement modal
  const handleCloseImplementsModal = () => {
    setShowImplementsModal(false);
    setSelectedImplements(null);
  };
//Rupali
 // Handle Individual CRM drill-down
  const handleIndividualcrmToggle = async (index, stateItem) => {
    console.log('handleIndividualcrmToggle called with:', { index, stateItem });
    if (expandedIndividualCrmIndex === index) {
      setExpandedIndividualCrmIndex(null);
      setExpandedIndividualCrmDistrictData([]);
    } else {
      setExpandedIndividualCrmIndex(index);
      setLoadingIndividualCrmDistrict(true);
      try {
        const apiPayload = {
          flag: "EXP_CRM_District",
          finYear: formatFinYearForApi(finYearFilter),
          stateCode: parseInt(stateItem.stateCode, 10) || 0
        };
        console.log('Individual CRM District API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('Individual CRM District API response:', data);
        if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
          const transformedData = data.dataContent.map(item => {
            const districtLabel = getDistrictLabel(item);
            return {
              districtCode: item.districtCode,
              districtName: districtLabel,
              districtNames: districtLabel,
              total: parseInt(item.total || item.count || item.totalUsers || 0, 10) || 0
            };
          });
          console.log('Transformed Individual CRM district data:', transformedData);
          setExpandedIndividualCrmDistrictData(transformedData);
        } else {
          setExpandedIndividualCrmDistrictData([]);
        }
      } catch (error) {
        console.error('Error fetching Individual CRM district details:', error);
        setExpandedIndividualCrmDistrictData([]);
      } finally {
        setLoadingIndividualCrmDistrict(false);
      }
    }
  };
  const handleIndividualsmamToggle = async (index, stateItem) => {
    console.log('handleIndividualsmamToggle called with:', { index, stateItem });
    if (expandedIndividualSmamIndex === index) {
      setExpandedIndividualSmamIndex(null);
      setExpandedIndividualSmamDistrictData([]);
    } else {
      setExpandedIndividualSmamIndex(index);
      setLoadingIndividualSmamDistrict(true);
      try {
        const apiPayload = {
          flag: "EXP_SMAM_District",
          finYear: formatFinYearForApi(finYearFilter),
          stateCode: parseInt(stateItem.stateCode, 10) || 0
        };
        console.log('Individual SMAM District API Payload:', apiPayload);

        const { data } = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MT/CentralDashBoardAll`,
          apiPayload,
          {
            headers: {
              'accept': '*/*',
              'Content-Type': 'application/json'
            }
          }
        );

        console.log('Individual SMAM District API response:', data);
        if (data.success && data.dataContent && Array.isArray(data.dataContent)) {
          const transformedData = data.dataContent.map(item => {
            const districtLabel = getDistrictLabel(item);
            return {
              districtCode: item.districtCode,
              districtName: districtLabel,
              districtNames: districtLabel,
              total: parseInt(item.total || item.count || item.totalUsers || 0, 10) || 0
            };
          });
          console.log('Transformed Individual SMAM district data:', transformedData);
          setExpandedIndividualSmamDistrictData(transformedData);
        } else {
          setExpandedIndividualSmamDistrictData([]);
        }
      } catch (error) {
        console.error('Error fetching Individual SMAM district details:', error);
        setExpandedIndividualSmamDistrictData([]);
      } finally {
        setLoadingIndividualSmamDistrict(false);
      }
    }
  };

  // Handle district toggle for individual SMAM 
  //Rupali
  useEffect(() => {
    fetchDashboardData();
    
    // Refresh User Details table if visible
    if (userVisible) {
      fetchUserDetails();
      setExpandedRowIndex(null);
      setExpandedRowData([]);
    }
    
    // Refresh CRM CHC table if visible
    if (crmVisible) {
      fetchCHCDetails();
      setExpandedDistrictIndex(null);
      setExpandedDistrictData([]);
    }
    
    // Refresh CRM Machine Demonstration table if visible
    if (crmDemoVisible) {
      fetchCRMDemoDetails();
      setExpandedCrmDemoStateIndex(null);
      setExpandedCrmDemoDistrictData([]);
    }
    
    // Refresh FMTTI Demonstration table if visible
    if (fmttiVisible) {
      fetchFMTTIDetails();
      setExpandedFmttiStateIndex(null);
      setExpandedFmttiDistrictData([]);
    }
    
    // Refresh SMAM CHC table if visible
    if (smamVisible) {
      fetchSMAMCHCDetails();
      setExpandedSmamChcStateIndex(null);
      setExpandedSmamChcDistrictData([]);
    }
    
    // Refresh API Data Report table if visible
    if (apiDataReportVisible) {
      fetchAPIDataReportDetails();
      setExpandedApiDataReportIndex(null);
      setExpandedApiDataReportDistrictData([]);
      setExpandedApiDataReportDistrictIndex(null);
      setExpandedApiDataReportDistrictDetailsData([]);
      setExpandedApiDataReportSubDistrictIndex(null);
      setExpandedApiDataReportSubDistrictDetailsData([]);
    }
  }, [finYearFilter]);

  return (
    <>
      {/* Active Users Card */}
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-danger card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">Active Users</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="totalUsers">{loading || localLoading ? 'Loading...' : dashboardData.activeUsers}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleMoreInfoClick('user')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Establish CRM CHC Card */}
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-primary card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">Establish CRM CHC</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="total">{loading || localLoading ? 'Loading...' : dashboardData.chcCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleMoreInfoClick('crm')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Establish SMAM CHC Card */}
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-success card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">Establish SMAM CHC</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="total">{loading || localLoading ? 'Loading...' : dashboardData.smamChcCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleMoreInfoClick('smam')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* FMTTI Demonstration Card */}
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-lite card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">FMTTI Demonstration</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="totalFarmers">{loading || localLoading ? 'Loading...' : dashboardData.fmttiCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleMoreInfoClick('fmtti')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* CRM Machine Demonstration Card */}
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-info card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">CRM Machine Demonstration</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="totalFarmers">{loading || localLoading ? 'Loading...' : dashboardData.crmDemoCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleMoreInfoClick('crmDemo')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>
       {/* API Data Report Card */}
       <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-mid card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">CRM CHC Data- API</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="crmapiCount">{loading || localLoading ? 'Loading...' : dashboardData.recordCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleMoreInfoClick('apiDataReport')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      
      {/* ICAR Card */}
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-primary card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">ICAR Machine Demonstration</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="icarCount">{loading || localLoading ? 'Loading...' : dashboardData.icarCount}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleMoreInfoClick('icar')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-danger card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">Individual Crm Survey</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="individualCrmCount">{loading || localLoading ? 'Loading...' : dashboardData.crM_Individual}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleMoreInfoClick('individualCrmSurvey')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xxl-4 col-xl-4">
        <div className="card info-card sales-card bg-gradient-lite card-img-holder">
          <div className="card-body">
            <img src={Circles} className="card-img-absolute" alt="circle-image" />
            <h5 className="card-title">Individual SMAM Survey</h5>
            <div className="d-flex align-items-center">
              <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
                <i><FontAwesomeIcon icon={faUsers} /> </i>
              </div>
              <div className="ps-3">
                <h6 id="individualSmamCount">{loading || localLoading ? 'Loading...' : dashboardData.smaM_Individual}</h6>
              </div>
            </div>
            <div className="mt-3">
              <button 
                className='btn btn-link p-0 text-white' 
                onClick={() => handleMoreInfoClick('individualSmamSurvey')}
                title="Click for more information"
              >
                <i className="bi bi-arrow-right-circle-fill fs-6">More Info</i>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Drill-down Tables Section */}
      <div className="row">
        {moreInfoLoading && !userVisible && !crmVisible && !fmttiVisible && !smamVisible && !crmDemoVisible && !apiDataReportVisible && !icarVisible && !individualCrmSurveyVisible && !individualSmamSurveyVisible && (
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3 mb-0">Loading details...</p>
              </div>
            </div>
          </div>
        )}
        {userVisible && (
          <div className="col-lg-12" id="user-details-table">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="card-title1 mb-0">Active Users Details</h5>
                  <button className="btn btn-sm btn-success" onClick={() => exportToCSV(userDetails, "MT_Active_Users_Report", ["S.No", "Role Name", "No of Users"])}>
                    Export CSV
                  </button>
                </div>
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Role</th>
                        <th>User Count</th>
                        <th style={{width: "100px", textAlign: "center"}}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userDetails && userDetails.length > 0 ? (
                        userDetails.map((user, index) => (
                          <React.Fragment key={index}>
                            <tr>
                              <td>{index + 1}</td>
                              <td>{user.userTypeName || 'N/A'}</td>
                              <td>{user.totalUsers || 0}</td>
                              <td style={{textAlign: "center"}}>
                                <span 
                                  role="button"
                                  onClick={() => handleRowToggle(index, user)}
                                  style={{
                                    cursor: "pointer",
                                    color: "#0d6efd",
                                    fontSize: "16px",
                                    fontWeight: "bold"
                                  }}
                                >
                                  {expandedRowIndex === index ? "-" : "+"}
                                </span>
                              </td>
                            </tr>
                            {expandedRowIndex === index && expandedRowData.length > 0 && (
                              <tr>
                                <td colSpan={4}>
                                  <div className="ms-4 mt-2">
                                    <table className="table table-sm table-bordered mb-0">
                                      <thead>
                                        <tr>
                                          <th>Sr. No.</th>
                                          <th>
                                            {(user.userTypeName === "FMTTI" || user.userTypeName === "Fmtti") 
                                              ? "Role" 
                                              : (user.userTypeName === "CRM" || user.userTypeName === "crm") 
                                                ? "Category Name" 
                                                : "State Name"}
                                          </th>
                                          <th>User Count</th>
                                          <th>Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {expandedRowData.map((item, idx) => {
                                          const isFMTTI = user.userTypeName === "FMTTI" || user.userTypeName === "Fmtti";
                                          const isCRM = user.userTypeName === "CRM" || user.userTypeName === "crm";
                                          const categoryUpper = (item.category || '').toUpperCase();
                                          const isCRM_ICAR = isCRM && (categoryUpper === "ICAR" || categoryUpper === "ICARDETAIL");
                                          const isCRM_STATE = isCRM && categoryUpper === "STATE";
                                          return (
                                            <React.Fragment key={idx}>
                                              <tr>
                                                <td>{idx + 1}</td>
                                                <td>
                                                  {isFMTTI
                                                    ? (item.fmttI_Name || 'N/A')
                                                    : isCRM
                                                      ? (item.category || 'N/A')
                                                      : (item.stateName || 'N/A')}
                                                </td>
                                                <td>{isFMTTI ? (item.userCount ?? 0) : (item.totalUsers || 0)}</td>
                                                
                                                  <td style={{textAlign: "center"}}>
                                                    <span 
                                                      role="button"
                                                      onClick={() => handleActiveUserDistrictToggle(idx, item, user.userTypeName)}
                                                      style={{
                                                        cursor: "pointer",
                                                        color: "#0d6efd",
                                                        fontSize: "16px",
                                                        fontWeight: "bold"
                                                      }}
                                                    >
                                                      {expandedDistrictIndex === idx ? "-" : "+"}
                                                    </span>
                                                  </td>
                                              
                                              </tr>
                                              {expandedDistrictIndex === idx && expandedDistrictData && expandedDistrictData.length > 0 && (
                                                <tr>
                                                  <td colSpan={4}>
                                                    <div className="ms-4 mt-2">
                                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <h5 className="mb-0">
                                                          {isCRM_STATE
                                                            ? "State Details"
                                                            : isCRM_ICAR
                                                              ? "ICAR Details"
                                                              : <>
                                                                  District Details for{" "}
                                                                  {isFMTTI
                                                                    ? (item.fmttI_Name)
                                                                    : isCRM
                                                                      ? (item.category || 'N/A')
                                                                      : (item.stateName || 'N/A')}
                                                                </>}
                                                        </h5>
                                                        <button 
                                                          className="btn btn-sm btn-outline-success" 
                                                          onClick={() => {
                                                            const csvHeaders = isFMTTI
                                                              ? ["S.No", "Role", "User Count"]
                                                              : isCRM_ICAR
                                                                ? ["S.No", "ATARI Name", "User Count"]
                                                                : ["S.No", isCRM_STATE ? "State Name" : "District Name", "User Count"];
                                                            const label = isFMTTI
                                                              ? (item.fmttI_Name)
                                                              : isCRM
                                                                ? (item.category || 'N/A')
                                                                : (item.stateName || 'N/A');
                                                            exportToCSV(
                                                              expandedDistrictData,
                                                              `MT_Active_Users_Districts_${label}`,
                                                              csvHeaders
                                                            );
                                                          }}
                                                        >
                                                          Export CSV
                                                        </button>
                                                      </div>
                                                      <table className="table table-sm table-bordered mb-0">
                                                        <thead>
                                                          <tr>
                                                            <th>Sr. No.</th>
                                                            <th>
                                                              {isFMTTI
                                                                ? "Role"
                                                                : isCRM_ICAR
                                                                  ? "Role"
                                                                  : isCRM_STATE
                                                                    ? "State Name"
                                                                    : "District Name"}
                                                            </th>
                                                            <th>User Count</th>
                                                            {isCRM_STATE && <th>Action</th>}
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {expandedDistrictData.map((district, districtIdx) => (
                                                            <React.Fragment key={districtIdx}>
                                                              <tr>
                                                                <td>{districtIdx + 1}</td>
                                                                <td>
                                                                  {isFMTTI
                                                                    ? (district.userRoleName || item.userRoleName || 'N/A')
                                                                    : isCRM_ICAR
                                                                      ? (district.atari_Name || district.districtNames || 'N/A')
                                                                      : (district.districtNames || district.districtName || 'N/A')}
                                                                </td>
                                                                <td>{district.totalUsers || 0}</td>
                                                                {isCRM_STATE && (
                                                                  <td style={{ textAlign: "center" }}>
                                                                    <span
                                                                      role="button"
                                                                      onClick={() => handleCrmStateDistrictToggle(districtIdx, district)}
                                                                      style={{
                                                                        cursor: "pointer",
                                                                        color: "#0d6efd",
                                                                        fontSize: "16px",
                                                                        fontWeight: "bold"
                                                                      }}
                                                                    >
                                                                      {expandedCrmStateIndex === districtIdx ? "-" : "+"}
                                                                    </span>
                                                                  </td>
                                                                )}
                                                              </tr>
                                                              {isCRM_STATE && expandedCrmStateIndex === districtIdx && expandedCrmStateDistrictData.length > 0 && (
                                                                <tr>
                                                                  <td colSpan={4}>
                                                                    <div className="ms-4 mt-2">
                                                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                                                        <h5 className="mb-0">
                                                                          District Details for {district.districtNames || district.districtName || 'N/A'}
                                                                        </h5>
                                                                        <button
                                                                          className="btn btn-sm btn-outline-success"
                                                                          onClick={() =>
                                                                            exportToCSV(
                                                                              expandedCrmStateDistrictData,
                                                                              `MT_Active_Users_Districts_${district.districtNames || district.districtName || 'N/A'}`,
                                                                              ["S.No", "District Name", "User Count"]
                                                                            )
                                                                          }
                                                                        >
                                                                          Export CSV
                                                                        </button>
                                                                      </div>
                                                                      <table className="table table-sm table-bordered mb-0">
                                                                        <thead>
                                                                          <tr>
                                                                            <th>Sr. No.</th>
                                                                            <th>District Name</th>
                                                                            <th>User Count</th>
                                                                          </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                          {expandedCrmStateDistrictData.map((dItem, dIdx) => (
                                                                            <tr key={dIdx}>
                                                                              <td>{dIdx + 1}</td>
                                                                              <td>{dItem.districtName}</td>
                                                                              <td>{dItem.totalUsers || 0}</td>
                                                                            </tr>
                                                                          ))}
                                                                        </tbody>
                                                                      </table>
                                                                    </div>
                                                                  </td>
                                                                </tr>
                                                              )}
                                                            </React.Fragment>
                                                          ))}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </td>
                                                </tr>
                                              )}
                                            </React.Fragment>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center">No user data available</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* CRM CHC Details Table */}
      {crmVisible && (
        <div className="col-lg-12" id="crm-details-table">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title1">CRM CHC Details</h5>
              <div className="d-flex justify-content-end mb-2">
                <button className="btn btn-sm btn-success" onClick={() => exportToCSV(crmChcDetails, "MT_CRM_CHC_Report", ["S.No", "State Name", "No of Users"])}>
                  Export CSV
                </button>
              </div>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>State</th>
                      <th>Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {crmChcDetails && crmChcDetails.length > 0 ? (
                      crmChcDetails.map((crm, index) => (
                        <>
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{crm.stateName || 'N/A'}</td>
                            <td>{crm.total || 0}</td>
                            <td>
                              <span 
                                role="button"
                                onClick={() => handleChcDistrictToggle(index, crm)}
                                style={{
                                  cursor: "pointer",
                                  color: "#0d6efd",
                                  fontSize: "16px",
                                  fontWeight: "bold"
                                }}
                              >
                                {expandedDistrictIndex === index ? "-" : "+"}
                              </span>
                            </td>
                          </tr>
                          {expandedDistrictIndex === index && expandedDistrictData.length > 0 && (
                            <tr>
                              <td colSpan="4">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h5 className="mb-0">District Details for {crm.stateName}</h5>
                                  <button 
                                    className="btn btn-sm btn-outline-success" 
                                    onClick={() => exportToCSV(expandedDistrictData, `MT_CRM_CHC_Districts_${crm.stateName}`, ["S.No", "District Name", "User Count"])}
                                  >
                                    Export CSV
                                  </button>
                                </div>
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Sr. No.</th>
                                      <th>District</th>
                                      <th>Count</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {expandedDistrictData.map((district, dIndex) => (
                                      <tr key={dIndex}>
                                        <td>{dIndex + 1}</td>
                                        <td>{district.districtNames || 'N/A'}</td>
                                        <td>{district.totalUsers || 0}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}
                        </>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">No CRM CHC data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FMTTI Details Table */}
      {fmttiVisible && (
        <div className="col-lg-12" id="fmtti-details-table">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title12">FMTTI Demonstration Details</h5>
              <div className="d-flex justify-content-end mb-2">
                <button className="btn btn-sm btn-success" onClick={() => exportToCSV(fmttiStateDetails, "MT_FMTTI_Report", ["S.No", "State Name", "No of Users"])}>
                  Export CSV
                </button>
              </div>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Institute</th>
                      <th>Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fmttiStateDetails && fmttiStateDetails.length > 0 ? (
                      fmttiStateDetails.map((fmtti, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{fmtti.fmttI_Name}</td>
                            <td>{fmtti.total || ''}</td>
                            <td>
                              <span 
                                role="button"
                                onClick={() => handleFmttiDemonstrationStateToggle(index, fmtti)}
                                style={{
                                  cursor: "pointer",
                                  color: "#0d6efd",
                                  fontSize: "16px",
                                  fontWeight: "bold"
                                }}
                              >
                                {expandedFmttiStateIndex === index ? "-" : "+"}
                              </span>
                            </td>
                          </tr>
                          {expandedFmttiStateIndex === index && expandedFmttiDistrictData.length > 0 && (
                            <tr>
                              <td colSpan="4">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h5 className="mb-0">State Details for {fmtti.fmttI_Name}</h5>
                                  <button 
                                    className="btn btn-sm btn-outline-success" 
                                    onClick={() => exportToCSV(expandedFmttiDistrictData, `MT_FMTTI_States_${fmtti.fmttI_Name}`, ["S.No", "State Name", "Count"])}
                                  >
                                    Export CSV
                                  </button>
                                </div>
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Sr. No.</th>
                                      <th>State</th>
                                      <th>Count</th>
                                      <th>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {expandedFmttiDistrictData.map((state, sIndex) => (
                                      <React.Fragment key={sIndex}>
                                        <tr>
                                          <td>{sIndex + 1}</td>
                                          <td>{state.stateName || 'N/A'}</td>
                                          <td>{state.total || 0}</td>
                                          <td>
                                            <span 
                                              role="button"
                                              onClick={() => handleFmttiDemonstrationDistrictToggle(sIndex, state)}
                                              style={{
                                                cursor: "pointer",
                                                color: "#0d6efd",
                                                fontSize: "16px",
                                                fontWeight: "bold"
                                              }}
                                            >
                                              {expandedFmttiDistrictIndex === sIndex ? "-" : "+"}
                                            </span>
                                          </td>
                                        </tr>
                                        {expandedFmttiDistrictIndex === sIndex && expandedFmttiDistrictDetailsData.length > 0 && (
                                          <tr>
                                            <td colSpan="4">
                                              <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h5 className="mb-0">District Details for {state.stateName}</h5>
                                                <button 
                                                  className="btn btn-sm btn-outline-success" 
                                                  onClick={() => exportToCSV(expandedFmttiDistrictDetailsData, `MT_FMTTI_Districts_${state.stateName}`, ["S.No", "District Name", "Count"])}
                                                >
                                                  Export CSV
                                                </button>
                                              </div>
                                              <table className="table table-bordered">
                                                <thead>
                                                  <tr>
                                                    <th>Sr. No.</th>
                                                    <th>District</th>
                                                    <th>Count</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {expandedFmttiDistrictDetailsData.map((district, dIndex) => (
                                                    <tr key={dIndex}>
                                                      <td>{dIndex + 1}</td>
                                                      <td>{getDistrictLabel(district)}</td>
                                                      <td>{district.total || 0}</td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </table>
                                            </td>
                                          </tr>
                                        )}
                                      </React.Fragment>
                                    ))}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">No FMTTI data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* SMAM CHC Details Table */}
      {smamVisible && (
        <div className="col-lg-12" id="smam-details-table">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title1">SMAM CHC Details</h5>
              <div className="d-flex justify-content-end mb-2">
                <button className="btn btn-sm btn-success" onClick={() => exportToCSV(smamChcDetails, "MT_SMAM_CHC_Report", ["S.No", "State Name", "No of Users"])}>
                  Export CSV
                </button>
              </div>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>State</th>
                      <th>Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {smamChcDetails && smamChcDetails.length > 0 ? (
                      smamChcDetails.map((smam, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{smam.stateName || 'N/A'}</td>
                            <td>{smam.total || 0}</td>
                            <td>
                              <span 
                                role="button"
                                onClick={() => handleSmamChcDistrictToggle(index, smam)}
                                style={{
                                  cursor: "pointer",
                                  color: "#0d6efd",
                                  fontSize: "16px",
                                  fontWeight: "bold"
                                }}
                              >
                                {expandedDistrictIndex === index ? "-" : "+"}
                              </span>
                            </td>
                          </tr>
                          {expandedDistrictIndex === index && expandedDistrictData.length > 0 && (
                            <tr>
                              <td colSpan="4">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h5 className="mb-0">District Details for {smam.stateName}</h5>
                                  <button 
                                    className="btn btn-sm btn-outline-success" 
                                    onClick={() => exportToCSV(expandedDistrictData, `MT_SMAM_CHC_Districts_${smam.stateName}`, ["S.No", "District Name", "User Count"])}
                                  >
                                    Export CSV
                                  </button>
                                </div>
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Sr. No.</th>
                                      <th>District</th>
                                      <th>Count</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {expandedDistrictData.map((district, dIndex) => (
                                      <tr key={dIndex}>
                                        <td>{dIndex + 1}</td>
                                        <td>{district.districtNames || 'N/A'}</td>
                                        <td>{district.totalUsers || 0}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">No SMAM CHC data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CRM Machine Demonstration Details Table */}
      {crmDemoVisible && (
        <div className="col-lg-12" id="crm-demo-table">
          <div className="card">
            <div className="card-body">
              <h5 className="card-title1">CRM Machine Demonstration Details</h5>
              <div className="d-flex justify-content-end mb-2">
                <button className="btn btn-sm btn-success" onClick={() => exportToCSV(crmDemoDetails, "MT_CRM_Demo_Report", ["S.No", "State Name", "No of Users"])}>
                  Export CSV
                </button>
              </div>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>State</th>
                      <th>Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {crmDemoDetails && crmDemoDetails.length > 0 ? (
                      crmDemoDetails.map((demo, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{demo.stateName || 'N/A'}</td>
                            <td>{demo.total || 0}</td>
                            <td>
                              <span 
                                role="button"
                                onClick={() => handleCrmDemoDistrictToggle(index, demo)}
                                style={{
                                  cursor: "pointer",
                                  color: "#0d6efd",
                                  fontSize: "16px",
                                  fontWeight: "bold"
                                }}
                              >
                                {expandedCrmDemoStateIndex === index ? "-" : "+"}
                              </span>
                            </td>
                          </tr>
                          {expandedCrmDemoStateIndex === index && expandedCrmDemoDistrictData.length > 0 && (
                            <tr>
                              <td colSpan="4">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <h5 className="mb-0">District Details for {demo.stateName}</h5>
                                  <button 
                                    className="btn btn-sm btn-outline-success" 
                                    onClick={() => exportToCSV(expandedCrmDemoDistrictData, `MT_CRM_Demo_Districts_${demo.stateName}`, ["S.No", "District Name", "User Count"])}
                                  >
                                    Export CSV
                                  </button>
                                </div>
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Sr. No.</th>
                                      <th>District</th>
                                      <th>Count</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {expandedCrmDemoDistrictData.map((district, dIndex) => (
                                      <tr key={dIndex}>
                                        <td>{dIndex + 1}</td>
                                        <td>{district.districtNames || 'N/A'}</td>
                                        <td>{district.totalFarmers || 0}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">No CRM demonstration data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* API Data Report Details Table */}
      {apiDataReportVisible && (
        <div className="row">
          <div className="col-lg-12" id="apiDataReport-details-table">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="card-title1 mb-0">API Data Report Details</h5>
                <button className="btn btn-sm btn-success" onClick={() => exportToCSV(apiDataReportDetails, "MT_API_Data_Report", ["S.No", "State Name", "Record Count"])}>
                  Export CSV 
                </button>
              </div>
             
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>State Name</th>
                      <th>Total</th>
                      <th>View Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiDataReportDetails && apiDataReportDetails.length > 0 ? (
                      apiDataReportDetails.map((report, index) => (
                        <React.Fragment key={report.stateCode || index}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{report.stateName || 'N/A'}</td>
                            <td>{report.total}</td>
                            <td>
                              <span 
                                role="button"
                                onClick={() => handleApiDataReportToggle(index, report)}
                                style={{
                                  cursor: "pointer",
                                  color: "#0d6efd",
                                  fontSize: "16px",
                                  fontWeight: "bold"
                                }}
                              >
                                {expandedApiDataReportIndex === index ? "-" : "+"}
                              </span>
                            </td>
                          </tr>
                         
                          {expandedApiDataReportIndex === index && (
                            <tr>
                              <td colSpan={4}>
                                <div className="ms-4 mt-2">
                                  {loadingApiDataReportDistrict ? (
                                    <div className="text-center py-4">
                                      <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                      <p className="mt-2 text-muted">Loading district details...</p>
                                    </div>
                                  ) : expandedApiDataReportDistrictData.length > 0 ? (
                                    <>
                                      <div className="d-flex justify-content-between align-items-center mb-2">
                                        <h5 className="mb-0">District Details for {report.stateName}</h5>
                                        <button 
                                          className="btn btn-sm btn-outline-success" 
                                          onClick={() => exportToCSV(expandedApiDataReportDistrictData, `MT_API_Data_Report_Districts_${report.stateName}`, ["S.No", "District Name", "Record Count"])}
                                        >
                                          Export CSV
                                        </button>
                                      </div>
                                  <table className="table table-sm table-bordered mb-0">
                                    <thead>
                                      <tr>
                                        <th>Sr. No.</th>
                                        <th>District Name</th>
                                        <th>Record Count</th>
                                        {/* <th>View Details</th> */}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {expandedApiDataReportDistrictData.map((district, dIndex) => (
                                        <React.Fragment key={district.districtCode || dIndex}>
                                          <tr>
                                            <td>{dIndex + 1}</td>
                                            <td>{district.districtName || 'N/A'}</td>
                                            <td>{district.recordCount || 0}</td>
                                            {/* <td>
                                              <span
                                                role="button"
                                                onClick={() => handleApiDataDistrictReportToggle(dIndex, district, report)}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "#198754",
                                                  fontSize: "16px",
                                                  fontWeight: "bold"
                                                }}
                                              >
                                                {expandedApiDataReportDistrictIndex === dIndex ? "-" : "+"}
                                              </span>
                                            </td> */}
                                          </tr>
                                          {expandedApiDataReportDistrictIndex === dIndex && expandedApiDataReportDistrictDetailsData.length > 0 && (
                                            <tr>
                                              <td colSpan={4}>
                                                <div className="ms-4 mt-2">
                                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <h5 className="mb-0">Sub District Details for {district.districtName}</h5>
                                                    <button 
                                                      className="btn btn-sm btn-outline-success" 
                                                      onClick={() => exportToCSV(expandedApiDataReportDistrictDetailsData, `MT_API_Data_Report_SubDistricts_${district.districtName}`, ["S.No", "Sub District Name", "Record Count"])}
                                                    >
                                                      Export CSV
                                                    </button>
                                                  </div>
                                                  <table className="table table-sm table-bordered mb-0">
                                                    <thead>
                                                      <tr>
                                                        <th>Sr. No.</th>
                                                        <th>Sub District Name</th>
                                                        <th>Record Count</th>
                                                        <th>View Details</th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {expandedApiDataReportDistrictDetailsData.map((block, bIndex) => (
                                                        <React.Fragment key={block.blockCode || bIndex}>
                                                          <tr>
                                                            <td>{bIndex + 1}</td>
                                                            <td>{block.blockName || 'N/A'}</td>
                                                            <td>{block.recordCount || 0}</td>
                                                            <td>
                                                              <span
                                                                role="button"
                                                                onClick={() => handleApiDataSubDistrictReportToggle(bIndex, block, district, report)}
                                                                style={{
                                                                  cursor: "pointer",
                                                                  color: "#198754",
                                                                  fontSize: "16px",
                                                                  fontWeight: "bold"
                                                                }}
                                                              >
                                                                {expandedApiDataReportSubDistrictIndex === bIndex ? "-" : "+"}
                                                              </span>
                                                            </td>
                                                          </tr>
                                                          {expandedApiDataReportSubDistrictIndex === bIndex && expandedApiDataReportSubDistrictDetailsData.length > 0 && (
                                                            <tr>
                                                              <td colSpan={4}>
                                                                <div className="ms-4 mt-2">
                                                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                                                    <h6 className="mb-0">CHC Details for {block.blockName}</h6>
                                                                    <button 
                                                                      className="btn btn-sm btn-outline-success" 
                                                                      onClick={() => exportToCSV(expandedApiDataReportSubDistrictDetailsData, `MT_API_Data_Report_CHC_${block.blockName}`, ["S.No", "CHC Name", "Village Name", "Record Count"])}
                                                                    >
                                                                      Export CSV
                                                                    </button>
                                                                  </div>
                                                                  <table className="table table-sm table-bordered mb-0">
                                                                    <thead>
                                                                      <tr>
                                                                        <th>Sr. No.</th>
                                                                        <th>CHC Name</th>
                                                                        <th>Address</th>
                                                                        <th>Registration No.</th>
                                                                        <th>Mobile No.</th>
                                                                        <th>Image</th>
                                                                        <th>No of Implement</th>
                                                                      </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                      {expandedApiDataReportSubDistrictDetailsData.map((chc, cIndex) => (
                                                                        <tr key={chc.id || cIndex}>
                                                                          <td>{cIndex + 1}</td>
                                                                          <td>{chc.chcName}</td>
                                                                          <td>{chc.landMarkAddress}</td>
                                                                          <td>{chc.societyRegistrationNumber}</td>
                                                                          <td>{chc.mobileNo}</td>
                                                                          <td>
                                                                            {chc.imagePath ? (
                                                                              <FontAwesomeIcon
                                                                                icon={faEye}
                                                                                onClick={() => handleImageView(chc.imagePath)}
                                                                                style={{
                                                                                  cursor: "pointer",
                                                                                  color: "#198754",
                                                                                  fontSize: "18px"
                                                                                }}
                                                                                title="View Image"
                                                                              />
                                                                            ) : (
                                                                              <span style={{ color: "#999" }}>N/A</span>
                                                                            )}
                                                                          </td>
                                                                          <td>
                                                                            {chc.noOfImplements > 0 ? (
                                                                              <span
                                                                                onClick={() => handleImplementsClick(chc)}
                                                                                style={{
                                                                                  cursor: "pointer",
                                                                                  color: "#0066cc",
                                                                                  textDecoration: "underline"
                                                                                }}
                                                                                title="Click to view implement details"
                                                                              >
                                                                                {chc.noOfImplements}
                                                                              </span>
                                                                            ) : (
                                                                              <span style={{ color: "#999" }}>0</span>
                                                                            )}
                                                                          </td>
                                                                        </tr>
                                                                      ))}
                                                                    </tbody>
                                                                  </table>
                                                                </div>
                                                              </td>
                                                            </tr>
                                                          )}
                                                        </React.Fragment>
                                                      ))}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </td>
                                            </tr>
                                          )}
                                        </React.Fragment>
                                      ))}
                                    </tbody>
                                  </table>
                                    </>
                                  ) : (
                                    <div className="text-center py-3 text-muted">
                                      <p>No district data available</p>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">No API Data Report available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        </div>
      )}

      {/* ICAR Details Table */}
      {icarVisible && (
        <div className="col-lg-12" id="icar-details-table">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="card-title1 mb-0">ICAR Details</h5>
                <button className="btn btn-sm btn-success" onClick={() => exportToCSV(icarDetails, "MT_ICAR_Report", ["S.No", "Atari Name", "Count"])}>
                  Export CSV
                </button>
              </div>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Atari</th>
                      <th>Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {icarDetails && icarDetails.length > 0 ? (
                      icarDetails.map((icar, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{icar.atari_Name || 'N/A'}</td>
                            <td>{icar.total || 0}</td>
                            <td>
                              <span 
                                role="button"
                                onClick={() => handleIcarAtariToggle(index, icar)}
                                style={{
                                  cursor: "pointer",
                                  color: "#0d6efd",
                                  fontSize: "16px",
                                  fontWeight: "bold"
                                }}
                              >
                                {expandedIcarAtariIndex === index ? "-" : "+"}
                              </span>
                            </td>
                          </tr>
                          {expandedIcarAtariIndex === index && (
                            <tr>
                              <td colSpan="4">
                                {loadingIcarKvk ? (
                                  <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2 text-muted">Loading KVK details...</p>
                                  </div>
                                ) : expandedIcarKvkData.length > 0 ? (
                                  <>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <h5 className="mb-0">KVK Details for {icar.atari_Name}</h5>
                                      <button 
                                        className="btn btn-sm btn-outline-success" 
                                        onClick={() => exportToCSV(expandedIcarKvkData, `MT_ICAR_KVK_${icar.atari_Name}`, ["S.No", "KVK Name", "Count"])}
                                      >
                                        Export CSV
                                      </button>
                                    </div>
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>Sr. No.</th>
                                          <th>KVK Name</th>
                                          <th>Count</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {expandedIcarKvkData.map((kvk, kIndex) => (
                                          <tr key={kIndex}>
                                            <td>{kIndex + 1}</td>
                                            <td>{kvk.kvkName || 'N/A'}</td>
                                            <td>{kvk.total || 0}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </>
                                ) : (
                                  <div className="text-center py-3 text-muted">
                                    <p>No KVK data available</p>
                                  </div>
                                )}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">No ICAR data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
       {/* individual Crm Details Table */}
      {individualCrmSurveyVisible && (
        <div className="col-lg-12" id="individual-crm-details-table">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="card-title1 mb-0">Individual CRM Details</h5>
                <button className="btn btn-sm btn-success" onClick={() => exportToCSV(individualCrmSurveyDetails, "MT_Individual_CRM_Report", ["S.No", "stateName", "total"])}>
                  Export CSV
                </button>
              </div>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>State</th>
                      <th>Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {individualCrmSurveyDetails && individualCrmSurveyDetails.length > 0 ? (
                      individualCrmSurveyDetails.map((crm, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{crm.stateName || 'N/A'}</td>
                            <td>{crm.total || 0}</td>
                            <td>
                              <span 
                                role="button"
                                onClick={() => handleIndividualcrmToggle(index, crm)}
                                style={{
                                  cursor: "pointer",
                                  color: "#0d6efd",
                                  fontSize: "16px",
                                  fontWeight: "bold"
                                }}
                              >
                                {expandedIndividualCrmIndex === index ? "-" : "+"}
                              </span>
                            </td>
                          </tr>
                          {expandedIndividualCrmIndex === index && (
                            <tr>
                              <td colSpan="4">
                                {loadingIndividualCrmDistrict ? (
                                  <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2 text-muted">Loading district details...</p>
                                  </div>
                                ) : expandedIndividualCrmDistrictData.length > 0 ? (
                                  <>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <h5 className="mb-0">District Details for {crm.stateName}</h5>
                                      <button 
                                        className="btn btn-sm btn-outline-success" 
                                        onClick={() => exportToCSV(expandedIndividualCrmDistrictData, `MT_Individual_CRM_Districts_${crm.stateName}`, ["S.No", "District Name", "Count"])}
                                      >
                                        Export CSV
                                      </button>
                                    </div>
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>Sr. No.</th>
                                          <th>District Name</th>
                                          <th>Count</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {expandedIndividualCrmDistrictData.map((district, dIndex) => (
                                          <tr key={dIndex}>
                                            <td>{dIndex + 1}</td>
                                            <td>{getDistrictLabel(district)}</td>
                                            <td>{district.total || 0}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </>
                                ) : (
                                  <div className="text-center py-3 text-muted">
                                    <p>No district data available</p>
                                  </div>
                                )}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">No Individual CRM data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
       {/* individual Smam Details Table */}
      {individualSmamSurveyVisible && (
        <div className="col-lg-12" id="individual-crm-details-table">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="card-title1 mb-0">Individual SMAM Details</h5>
                <button className="btn btn-sm btn-success" onClick={() => exportToCSV(individualSmamSurveyDetails, "MT_Individual_SMAM_Report", ["S.No", "State", "Count"])}>
                  Export CSV
                </button>
              </div>
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>State</th>
                      <th>Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {individualSmamSurveyDetails && individualSmamSurveyDetails.length > 0 ? (
                      individualSmamSurveyDetails.map((smam, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{index + 1}</td>
                            <td>{smam.stateName || 'N/A'}</td>
                            <td>{smam.total || 0}</td>
                            <td>
                              <span 
                                role="button"
                                onClick={() => handleIndividualsmamToggle(index, smam)}
                                style={{
                                  cursor: "pointer",
                                  color: "#0d6efd",
                                  fontSize: "16px",
                                  fontWeight: "bold"
                                }}
                              >
                                {expandedIndividualSmamIndex === index ? "-" : "+"}
                              </span>
                            </td>
                          </tr>
                          {expandedIndividualSmamIndex === index && (
                            <tr>
                              <td colSpan="4">
                                {loadingIndividualSmamDistrict ? (
                                  <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                      <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2 text-muted">Loading district details...</p>
                                  </div>
                                ) : expandedIndividualSmamDistrictData.length > 0 ? (
                                  <>
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <h5 className="mb-0">District Details for {smam.stateName}</h5>
                                      <button 
                                        className="btn btn-sm btn-outline-success" 
                                        onClick={() => exportToCSV(expandedIndividualSmamDistrictData, `MT_Individual_SMAM_Districts_${smam.stateName}`, ["S.No", "District Name", "Count"])}
                                      >
                                        Export CSV
                                      </button>
                                    </div>
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>Sr. No.</th>
                                          <th>District Name</th>
                                          <th>Count</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {expandedIndividualSmamDistrictData.map((district, dIndex) => (
                                          <tr key={dIndex}>
                                            <td>{dIndex + 1}</td>
                                            <td>{getDistrictLabel(district)}</td>
                                            <td>{district.total || 0}</td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </>
                                ) : (
                                  <div className="text-center py-3 text-muted">
                                    <p>No district data available</p>
                                  </div>
                                )}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} className="text-center">No Individual SMAM data available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Image Modal */}
      {showImageModal && selectedImageUrl && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          tabIndex="-1"
          aria-labelledby="imageModalLabel"
          aria-hidden="false"
          onClick={handleCloseImageModal}
        >
          <div 
            className="modal-dialog modal-lg modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="imageModalLabel">
                  CHC Image
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseImageModal}
                  aria-label="Close"
                >x</button>
              </div>
              <div className="modal-body text-center">
                <img
                  src={selectedImageUrl}
                  alt="CHC Image"
                  className="img-fluid"
                  style={{ maxHeight: '70vh' }}
                  onError={(e) => {
                    console.error('Image failed to load:', e.target.src);
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<p class="text-danger">Failed to load image</p>';
                  }}
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseImageModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Implement Details Modal */}
      {showImplementsModal && selectedImplements && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(193, 183, 183, 0)' }}
          tabIndex="-1"
          aria-labelledby="implementModalLabel"
          aria-hidden="false"
          onClick={handleCloseImplementsModal}
        >
          <div 
            className="modal-dialog modal-lg modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#c9ebc9', borderBottom: '0px solid #dee2e6' }}>
                <h5 className="modal-title" id="implementModalLabel" style={{ fontWeight: 'bold' }}>
                  Implement Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseImplementsModal}
                  aria-label="Close"
                 
                >x</button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <p><strong>CHC Name:</strong> {selectedImplements.chcName}; <strong>Total Implements:</strong> {selectedImplements.noOfImplements}</p>
                  
                </div>
                <div className="table-responsive">
                  <table className="table table-bordered table-striped">
                    <thead className="table-light123">
                      <tr>
                        <th style={{ width: '10%' }}>S.No</th>
                        <th style={{ width: '45%' }}>Category Name</th>
                        <th style={{ width: '45%' }}>Implement Name</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        try {
                          const implementDetails = selectedImplements.implementDetailsJSON 
                            ? JSON.parse(selectedImplements.implementDetailsJSON) 
                            : [];
                          
                          if (implementDetails.length === 0) {
                            return (
                              <tr>
                                <td colSpan="3" className="text-center">No implement details available</td>
                              </tr>
                            );
                          }
                          
                          return implementDetails.map((item, index) => {
                            // Parse ImplementSubsidyName to extract Implement Name and Category Name
                            let implementName = 'N/A';
                            let categoryName = 'N/A';
                            
                            if (item.ImplementSubsidyName) {
                              const parts = item.ImplementSubsidyName.split(' - ');
                              if (parts.length === 2) {
                                implementName = parts[0].trim();
                                categoryName = parts[1].trim();
                              } else {
                                // If format is different, use the whole string as implement name
                                implementName = item.ImplementSubsidyName;
                              }
                            } else if (item.ImplementName && item.CategoryName) {
                              // Fallback to direct fields if available
                              implementName = item.ImplementName;
                              categoryName = item.CategoryName;
                            }
                            
                            return (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{categoryName}</td>
                                <td>{implementName}</td>
                              </tr>
                            );
                          });
                        } catch (error) {
                          console.error('Error parsing implement details:', error);
                          return (
                            <tr>
                              <td colSpan="3" className="text-center text-danger">Error loading implement details</td>
                            </tr>
                          );
                        }
                      })()}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer" style={{ backgroundColor: '#c9ebc9', borderTop: '1px solid #dee2e6' }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseImplementsModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CentralLoginDashboard;